/* eslint-disable no-undef */
import {
  writeContract,
  getBalance,
  watchContractEvent,
  watchConnections,
} from "@wagmi/core";
import { getAccount, disconnect, multicall } from "@wagmi/core";
import { useReconnect, useConnect, useAccount } from "wagmi";

import { ethers } from "ethers";

import "./page2.css";
import logo from "@/assets/imgs/page2/logo.svg";
import ellipse from "@/assets/imgs/page2/logo.svg";
import ellipse2 from "@/assets/imgs/page2/icon_game.jpg";
import card_top_icon from "@/assets/imgs/page2/card_top_icon.png";
import card_bottom_icon from "@/assets/imgs/page2/card_bottom_icon.png";
import { config } from "../../config";
import { useState, useEffect } from "react";
import { mainnet } from "viem/chains";
import { notification } from "antd";

const contractGameAddress = "0xb141fF705Aef654C13dA8A96C4ABb20BB8E286b2";
const gameTokenAddress = "0x825459139C897D769339f295E962396C4F9E4A4D";
//const activeTokenAddress = "0x331E3Bd73aD3134037bf6fb7a0213785c3962972";
const contractCRE = "0x115eC79F1de567eC68B7AE7eDA501b406626478e";
const contractSLG = "0xFc0B60E0DF5Dc9d4B72D957cA2d251ceE308019a";

const abi = [
  {
    inputs: [{ internalType: "uint256", name: "amountCRE", type: "uint256" }],
    name: "swapCRE",
    outputs: [{ internalType: "uint256", name: "amountGame", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "account", type: "address" }],
    name: "balanceOf",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
];

const creAbi = [
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "value", type: "uint256" },
    ],
    name: "approve",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "account", type: "address" }],
    name: "balanceOf",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, name: "owner", type: "address" },
      { indexed: true, name: "spender", type: "address" },
      { indexed: false, name: "value", type: "uint256" },
    ],
    name: "Approval",
    type: "event",
  },
];

const swapEventAbi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Swap",
    type: "event",
  },
];

const Page2 = () => {
  const SWAP_STATUS_IDLE = "idle";
  const SWAP_STATUS_ONGOING = "ongoing";

  const [showPop1, setShowPop1] = useState(false);
  const [account, setAccount] = useState("");
  const [CREAmount, setCREAmount] = useState("--");
  const [GAMEOwned, setGAMEOwned] = useState("--");
  const [input_info, setInput_info] = useState("");
  const [GAMEAmount, setGAMEAmount] = useState("- -");
  const [activeToken, setActiveToken] = useState("CRE");
  const [activeTokenAddress, setActiveTokenAddress] = useState("");
  const [btn_info, setBtn_info] = useState("Connect Wallet");
  const [token_info, setToken_info] = useState("CRE");
  const [ratioText, setRatioText] = useState("1 CRE = 1 GAME");
  const [swapStatus, setSwapStatus] = useState(SWAP_STATUS_IDLE);

  const optData = ["CRE", "SLG"];
  const [optStatus, setOptStatus] = useState("CRE");

  Number.prototype.toFixed = function (dig = 6) {
    return Math.floor(this * 10 ** dig) / 10 ** dig;
  };

  const { reconnect, connectors } = useReconnect({ config });
  const currentAccount = useAccount({
    onConnect({ address, connector, isReconnected }) {
      console.log("Connected", { address, connector, isReconnected });
    },
  });
  const { connect } = useConnect({ config });
  const { isConnected } = useAccount({ config });

  useEffect(() => {
    if (CREAmount === "--") {
      console.log("CREAmount is --");
    } else {
      reconnect({ connectors });
      console.log(CREAmount);
    }
  }, [CREAmount]);

  useEffect(() => {
    if (btn_info !== "Connect Wallet") {
      connect(connectors[0]);
      console.log("button info change!--------");
      //console.log("connectors include", connectors);
      console.log("isConnected", isConnected);
    }
  }, [btn_info]);

  useEffect(() => {
    if (optStatus === "CRE") {
      setActiveTokenAddress("0x115eC79F1de567eC68B7AE7eDA501b406626478e");
      setToken_info("CRE");
      setRatioText("1 CRE = 1 GAME");
      setActiveToken("CRE");
    } else if (optStatus === "SLG") {
      setActiveTokenAddress("0xFc0B60E0DF5Dc9d4B72D957cA2d251ceE308019a");
      setToken_info("SLG");
      setRatioText("1 SLG = 11.4196 GAME");
      setActiveToken("SLG");
    }
  }, [optStatus]);

  useEffect(() => {
    const walletAccount = getAccount(config);
    connect(connectors[0]);
    console.log("it is connected here", isConnected);
    if (walletAccount.address !== undefined) {
      getActiveTokenBalanceOfWallet(walletAccount.address);
    }
  }, [GAMEOwned]);

  useEffect(() => {
    const walletAccount = getAccount(config);
    setCREAmount("--");
    setGAMEAmount("- -");
    console.log("active token address in use effect:", activeTokenAddress);
    if (walletAccount.address !== undefined) {
      console.log("Getting Balance again");
      getActiveTokenBalanceOfWallet(walletAccount.address);
    }
  }, [activeTokenAddress]);

  useEffect(() => {
    const disconnectWallet = async () => {
      try {
        await disconnect(config);
        setAccount("Connect Wallet");
        setCREAmount("--");
        setGAMEAmount("- -");
        setBtn_info("Connect Wallet");
      } catch (error) {
        console.log("Error disconnecting wallet:", error);
      }
    };

    disconnectWallet();
  }, []);

  const unwatchWatchConnections = watchConnections(config, {
    onChange(data) {
      if (data[0] === undefined) {
        if (account !== "Connect Wallet") {
          setAccount("Connect Wallet");
          setGAMEOwned("--");
          setCREAmount("--");
          setGAMEAmount("- -");
          setBtn_info("Connect Wallet");
        }
        return;
      }
      if (data[0].accounts[0] !== undefined) {
        const walletAccount = getAccount(config);
        // Set the button text to a short version of the wallet address
        const shortAddress = `${walletAccount.address.slice(
          0,
          6
        )}...${walletAccount.address.slice(-4)}`;
        setBtn_info(shortAddress);

        setAccount(walletAccount.address);
        getAllBalance(walletAccount.address);
      } else {
        setAccount("Connect Wallet");
      }
    },
  });

  const getAllBalance = async (walletAddress) => {
    try {
      const result = await multicall(config, {
        contracts: [
          {
            // get CRE/SLG Balance
            address: activeTokenAddress,
            functionName: "balanceOf",
            abi: creAbi,
            args: [walletAddress],
          },
          {
            // get GAME Balance
            address: gameTokenAddress,
            functionName: "balanceOf",
            abi: abi,
            args: [walletAddress],
          },
        ],
      });

      const creamount = Number(result[0].result) / 1000000000000000000;
      const gameamount = Number(result[1].result) / 1000000000000000000;
      setCREAmount(creamount.toFixed(6));
      if (optStatus === "CRE") {
        setGAMEAmount(creamount.toFixed(6));
      } else if (optStatus === "SLG") {
        setGAMEAmount(creamount.toFixed(6) / 11.4196394);
      }
      setGAMEOwned(gameamount.toFixed(6));
    } catch (error) {
      console.log("error", error);
    }
  };

  const getActiveTokenBalanceOfWallet = async (walletAddress) => {
    try {
      const balance = await getBalance(config, {
        address: walletAddress,
        token: activeTokenAddress,
        chainId: mainnet.id,
      });
      const formattedBalance = parseFloat(balance.formatted).toFixed(6);
      setCREAmount(formattedBalance);
      if (optStatus === "CRE") {
        setGAMEAmount(formattedBalance);
      } else if (optStatus === "SLG") {
        setGAMEAmount(formattedBalance / 11.4196394);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const getGameBalanceOfWallet = async (walletAddress) => {
    try {
      const balance = await getBalance(config, {
        address: walletAddress,
        token: gameTokenAddress,
        chainId: mainnet.id,
      });
      const formattedBalance = parseFloat(balance.formatted).toFixed(4);
      setGAMEOwned(formattedBalance);
    } catch (error) {
      console.log("error", error);
    }
  };

  const swapCRE = async (amount) => {
    try {
      const response = await writeContract(config, {
        abi: abi,
        address: contractGameAddress,
        functionName: "swapCRE",
        args: [amount],
      });
      const unwatch = watchContractEvent(config, {
        address: contractGameAddress,
        abi: swapEventAbi,
        eventName: "Swap",
        onLogs(logs) {
          openNotification(amount / 1000000000000000000n);
          unwatch();
          setSwapStatus(SWAP_STATUS_IDLE);
          const walletAccount = getAccount(config);
          getGameBalanceOfWallet(walletAccount.address);
        },
      });
    } catch (error) {
      console.log("error", error);
    }
    setSwapStatus(SWAP_STATUS_IDLE);
  };
  const handleSwap = async (amount) => {
    try {
      setSwapStatus(SWAP_STATUS_ONGOING);
      const creApprovalAmount = ethers.parseUnits(amount.toString(), 18);

      // 设置提供者和签名者
      const provider = new ethers.BrowserProvider(window.ethereum);
      await provider.send("eth_requestAccounts", []); // 请求用户授权

      const signer = await provider.getSigner();
      const contract = new ethers.Contract(activeTokenAddress, creAbi, signer);
      swapCRE(creApprovalAmount);
    } catch (error) {
      console.log("error", error);
      setSwapStatus(SWAP_STATUS_IDLE);
      notification.info({
        message: `Transaction failed`,
        placement: "bottomRight",
        duration: 10,
      });
    }
  };
  const handleApprove = async (amount) => {
    try {
      setSwapStatus(SWAP_STATUS_ONGOING);
      const creApprovalAmount = ethers.parseUnits(amount.toString(), 18);

      // 设置提供者和签名者
      const provider = new ethers.BrowserProvider(window.ethereum);
      await provider.send("eth_requestAccounts", []); // 请求用户授权

      const signer = await provider.getSigner();
      const contract = new ethers.Contract(activeTokenAddress, creAbi, signer);

      // 调用 approve 函数
      const approval = await contract.approve(
        contractGameAddress,
        creApprovalAmount
      );

      // 检查交易回执
      const receipt = await approval.wait();
      console.log("Transaction receipt:", receipt);
    } catch (error) {
      console.log("error", error);
      setSwapStatus(SWAP_STATUS_IDLE);
      notification.info({
        message: `Transaction failed`,
        placement: "bottomRight",
        duration: 10,
      });
    }
  };

  const card_top_fn = () => {
    console.log("card_top_fn");
  };

  const max_fn = () => {
    setInput_info(CREAmount);
  };

  const input_fn = (event) => {
    const inputValue = event.target.value;
    const [integerPart, decimalPart] = CREAmount
      ? CREAmount.toString().split(".")
      : [0, 0];
    const [newIntegerPart, newDecimalPart] = inputValue.split(".");

    if (inputValue.indexOf(".") !== -1 && newDecimalPart === decimalPart) {
      const newValue = `${newIntegerPart}.${decimalPart}`;

      if (newIntegerPart !== "" && /^\d*\.?\d*$/.test(newValue)) {
        setInput_info(newValue);
      }
    } else {
      if (/^\d*$/.test(inputValue)) {
        setInput_info(inputValue);
      }
    }
  };

  const onSelectChange = (e) => {
    setOptStatus(e.target.value);
  };

  const openNotification = (placement) => {
    const gameAmount = Number(placement) / 1;
    notification.open({
      message: `Swap Successful!`,
      description: `${placement} ${activeToken} has been swapped to ${gameAmount} GAME`,
      placement: "bottomRight",
      duration: 10,
    });
  };

  const [mobileClass, setMobileClass] = useState("");
  function isMobile() {
    const mobileRegex =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    return navigator.userAgent.match(mobileRegex);
  }

  useEffect(() => {
    if (isMobile()) {
      setMobileClass("mobileStyle");
    } else {
      setMobileClass("");
    }
  }, []);

  return (
    <>
      <section className={"page2 fit-out " + mobileClass}>
        <div className="swapU row-out">
          <div className="swap">Please Swap with a Browser on a Computer</div>
        </div>
        <div className="logo_h5"></div>
        <div className="boxU">
          <div className="title">Swap</div>
          <div className="title-label">{token_info} to GAME</div>
          <form className="form" action="#" method="get">
            <div className="top">
              <div className="card type1">
                <div className="ellipse">
                  <img className="wh-all" src={ellipse} alt="" />
                </div>
                {/* <div className="ellipse"></div> */}
                <div className="right">
                  <div className="label">{optStatus}</div>
                  {/* <select
                  className="label"
                  value={optStatus}
                  onChange={onSelectChange}
                >
                  {optData.map((opt) => (
                    <option key={opt}>{opt}</option>
                  ))}
                </select> */}
                  <div className="value">{CREAmount.toLocaleString()}</div>
                </div>
              </div>
              <div className="card type2">
                <div className="ellipse">
                  <img className="wh-all" src={ellipse2} alt="" />
                </div>
                {/* <div className="ellipse"></div> */}
                <div className="right">
                  <div className="label">GAME</div>
                  <div className="value">{GAMEAmount.toLocaleString()}</div>
                </div>
              </div>
              <div className="disable_h5 icon" onClick={card_top_fn}>
                <img className="wh-all" src={card_top_icon} alt="" />
              </div>
            </div>
            <div className="bottom">
              <label className="input1">
                <div className="label">{token_info} Amount</div>
                <div className="input-box">
                  <div className="prefix-icon"></div>
                  <input
                    placeholder="Enter an amount"
                    className="input"
                    type="text"
                    value={input_info}
                    onChange={input_fn}
                  />
                  <div className="disable_h5 btn flex-in" onClick={max_fn}>
                    MAX
                  </div>
                </div>
              </label>
              <div className="hr">
                <div className="line"></div>
                <img className="icon" src={card_bottom_icon} alt="" />
              </div>
              <div className="row-out col-in">
                <div className="amount">
                  <div className="label-box">
                    <div className="label">Game Balance</div>
                    <div className="label1">{ratioText}</div>
                  </div>
                  <div className="value">{GAMEOwned.toLocaleString()}</div>
                </div>
                <div>
                  <div className="col-in row-end mb10">
                    <div
                      className={`disable_h5 swap flex-in`}
                      onClick={() => {
                        handleApprove(parseFloat(input_info));
                      }}
                    >
                      Approve
                    </div>
                    <div
                      className={`disable_h5 swap flex-in`}
                      onClick={() => {
                        handleSwap(parseFloat(input_info));
                      }}
                    >
                      Swap
                    </div>
                  </div>
                  <p className="label">Please Approve before Swap </p>
                </div>
              </div>
              <div className="disable_h5 submit-btn">
                <w3m-button className="w3m-button wh-all">
                  Connect Wallet
                </w3m-button>
                <div
                  className={`btn ${
                    swapStatus === SWAP_STATUS_ONGOING
                      ? "SWAP_STATUS_ONGOING"
                      : ""
                  }`}
                >
                  {btn_info}
                </div>
              </div>
            </div>
          </form>
        </div>
      </section>
      {/* {showPop1 && (
        <Pop1
          onClose={() => setShowPop1(false)}
          account={account}
          onAccountConnected={handleAccountConnected}
        />
      )} */}
    </>
  );
};

export default Page2;
